import * as React from 'react';

function SvgReconciliationComingsoon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 30" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13.503 5.932c.321 0 .63.13.856.361l6.493 5.965a9.013 9.013 0 00-6.632 6.755h-1.943c-.68 0-1.229.56-1.229 1.25V24H4.611c-.68 0-1.228-.56-1.228-1.246v-7.951l9.263-8.51c.227-.231.535-.361.857-.361zM13.5 0c.99 0 1.922.386 2.63 1.085l10.351 9.616a1.572 1.572 0 01.133 2.2l.085-.107a8.954 8.954 0 00-3.358-.788l-9.343-8.682a.7.7 0 00-.999 0l-.07.067-10.382 9.646A1.519 1.519 0 01.382 12.9a1.577 1.577 0 01.137-2.2l10.35-9.615A3.721 3.721 0 0113.5 0z"
          fill="#445A98"
        />
        <path d="M22.999 28a7 7 0 006.999-7 7 7 0 10-7 7z" fill="#445A98" />
        <path
          d="M23.222 20.555h2.667a1.11 1.11 0 110 2.222H21v-4.666a1.111 1.111 0 012.222 0v2.444z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgReconciliationComingsoon;
